<template>
  <div class="master-data mt-2">

    <keep-alive>
      <component :is="currentTabComponent" v-bind="currentProperties" v-on:refreshOrganisation="getOrganisation">
      </component>
    </keep-alive>
    <OrganisationKpiConfig v-bind:organization="this.organisation" v-if="this.organisation.plants">
    </OrganisationKpiConfig>
  </div>
</template>
<script>
import { createToast } from '@/assets/js/myToast.js'
import EditOrganisation from '@/components/masterdata/EditOrganisation.vue';
import OrganisationKpiConfig from '@/components/kpi/OrganisationKpiConfig.vue'
import axios from 'axios'
export default {
  name: 'Masterdata',
  components: {
    EditOrganisation,
    OrganisationKpiConfig
  },
  data() {
    return {
      currentTabComponent: "EditOrganisation",
      organisation: {}
    }
  },
  async mounted() {
    await this.getOrganisation()
  },
  methods: {
    getOrganisation() {
      const organisationID = this.$store.state.me.organisation

      axios
        .get(`/api/v1/allOrganisations/${organisationID}/`)
        .then(response => {
          this.organisation = response.data
        })
        .catch(error => {
          console.log(JSON.stringify(error))
        })
    },
    refreshOrganisation() {
      console.log('entry refreshOrganisation')

      const organisationID = this.$store.state.me.organisation

      axios
        .get(`/api/v1/organisations/${organisationID}/`)
        .then(response => {
          this.$store.commit('setOrganisation', response.data)
        })
        .catch(error => {
          console.log(JSON.stringify(error))
        })
    }
  },
  computed: {

    canReadUser() {
      return this.$store.getters.userHasPermission('user', 'can_read')
    },
    currentProperties() {
      return { organisation: this.$store.getters.getOrganisation }
    },
    getModalName() {

    }
  }
}
</script>